import api from '../api/axios';

export interface TimeEntry {
  id?: number;
  employee: number;
  project?: number;
  task?: number;
  date: string;
  startTime?: string;
  endTime?: string;
  hours: number;
  description?: string;
  billable?: boolean;
  hourlyRate?: number;
  totalCost?: number;
}

const TimeEntryService = {
  getAll: (params?: any) => api.get('/time-entries', { params }),
  getOne: (id: number) => api.get(`/time-entries/${id}`, { params: { populate: '*' } }),
  create: (data: TimeEntry) => api.post('/time-entries', { data }),
  update: (id: number, data: Partial<TimeEntry>) => api.put(`/time-entries/${id}`, { data }),
  delete: (id: number) => api.delete(`/time-entries/${id}`),
};

export default TimeEntryService;
